class ScriptLoader {
  constructor(app) {
    this.app = app;
    this.path = app.lookup('vocento.config.nibara').path;
    if (this.path === undefined) {
      throw 'nibara path config is empty';
    }
  }

  initialize() {
    Logger.debug('ScriptLoader: Initialize');

    let categoriesStr = Voonto.$('body').data('nibara-loader');
    if (categoriesStr) {
      categoriesStr.split(" ").forEach((category) => {
        if (category.trim().length>0) { //Evita los espacios blancos grandes o continuos
          let scriptName = this.path + `/${category}-script.js`;
          scriptName = window.nibara.nTools.getStaticNode(scriptName);
          Logger.debug('ScriptLoader: loading script: ' + scriptName);
          //Logger.debug('ScriptLoader: loading script: ' + category);
          this.app.load(scriptName).catch((e) => {
            Logger.error(scriptName + ' not found: ' + e.message);
          });
        }
      });
    }
    Logger.debug('ScriptLoader End');
  }
}

export default ScriptLoader;



// WEBPACK FOOTER //
// ./src/ScriptLoader.js